import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { AttendanceAdjustment } from "../entities/attendance-adjustment.entity";

@EntityRepository(AttendanceAdjustment)
export class AttendanceAdjustmentRepository extends Repository<AttendanceAdjustment> {

    constructor() {
        super();
    }

}